import React, { useEffect, useRef, useState } from "react";
import { Input } from "../../../Components/FormElements";
import { PrimaryButton } from "../../../Components/Cta";
import OtpModal from "../../../Components/Modals/otp-modal";
import { DatePickerSingle } from "../../../Components/Calender";

export default function Stage2({ setTitle, updateData, changePage }) {
  const otpInputRef = useRef(null);
  const [startDate, setStartDate] = useState();
  const [DateError, setDateError] = useState();
  const [otpModal, setOtpModal] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [focusedInput, setFocusedInput] = useState(2);
  const [confirmOTP, setConfirmOTP] = useState([]);
  const [otpError, setOtpError] = useState("");
  useEffect(() => {
    setTitle("Account setup");
  }, [setTitle]);

  useEffect(() => {
    if (otpInputRef) return;
    otpInputRef.current[0]?.focus();
  }, []);
  const _handleOTP = (e) => {
    const input_value = e.target.value;
    if (input_value.length <= 4) {
      setOtpValue(input_value);
      const characters = [];

      for (let i = 0; i < input_value.length; i++) {
        const character = input_value.charAt(i);
        characters.push(character);
      }
      setConfirmOTP(characters);
    }
  };

  const [pan, setPan] = useState("");
  const [panError, setPanError] = useState("");

  // PAN Regex: 5 letters, 4 digits, 1 letter
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

  const validatePan = (value) => {
    if (!value.trim()) return "PAN is required";
    if (!panRegex.test(value)) return "Invalid PAN format (e.g. ABCDE1234F)";
    return "";
  };

  const handleChange = (val) => {
    const value = val.toUpperCase();

    // 1️⃣ Block special characters or spaces
    if (/[^A-Z0-9]/.test(value)) {
      setPanError(" PAN cannot contain special characters or spaces");
      return; // stop updating pan state
    }

    // 2️⃣ Block length > 10
    if (value.length > 10) {
      setPanError(" PAN must be exactly 10 characters");
      return;
    }

    // 3️⃣ Run format validation if already 10 chars
    if (value.length === 10) {
      const err = validatePan(value); // your PAN regex validator
      setPanError(err);
    } else {
      setPanError(""); // clear error while typing
    }

    // 4️⃣ Update state
    setPan(value);
  };

  const _handleSubmitOTP = () => {
    if (otpValue !== "1234") {
      // example validation
      setOtpError("Invalid OTP");
      setOtpValue(""); // clear input
      setConfirmOTP([]);
      setFocusedInput(2); // refocus input
      if (otpInputRef.current) {
        otpInputRef.current.focus();
      }
    } else {
      setOtpError("");
      changePage(3);
    }
  };

  const _handleSubmit = () => {
    setDateError("")
    const err = validatePan(pan);
    setPanError(err);

    if (!startDate) {
      setDateError("Select a Date");
      return;
    }

    // Age restriction: must be 18+
    const today = new Date();
    const dob = new Date(startDate);
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    if (age < 18) {
      setDateError("You must be at least 18 years old to proceed");
      return;
    }

    if (err) return; // stop if PAN error

    updateData((prev) => ({ ...prev, pan, startDate }));
    setOtpModal(true);
  };

  return (
    <div className="row row-gap-4">
      <div className="col-12 d-flex flex-column">
        <div className="p-3 d-flex flex-column row-gap-3 mt-1 e-bg-ghost-white-dark e-border-radius-16 e-border-1px-pale-lavender">
          <Input
            require
            type="text"
            label="PAN"
            labelStyle="e-font-16 e-font-weight-400 e-primary-font-poppins pb-2"
            placeholder="Enter PAN"
            className="w-100 pe-lg-5"
            value={pan}
            error={panError}
            handleChange={handleChange}
            onBlur={() => setPanError(validatePan(pan))}
          />
          <DatePickerSingle
            label="Date of Birth"
            require={true}
            labelStyle="e-font-16 e-font-weight-400 e-primary-font-poppins pb-2"
            startDate={startDate}
            onChange={setStartDate}
            placeholder="Select DOB"
            error={DateError}
          />
        </div>
      </div>

      {/* CTA Buttons */}
      <div className="col-lg-10 offset-lg-2 col-12">
        <div className="row">
          <div className="col-6">
            <PrimaryButton
              ClassName="e-border-radius-pill e-border-1px-blue py-3 e-font-weight-500 e-font-16 w-100 bg-transparent e-text-blue-violet e-primary-font-poppins"
              name="Go back"
              onPress={() => changePage(1)}
            />
          </div>
          <div className="col-6">
            <PrimaryButton
              ClassName="e-border-radius-pill e-font-weight-500 py-3 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
              name="Verify"
              onPress={_handleSubmit}
            />
          </div>
        </div>
      </div>
      {otpModal && (
        <OtpModal
          otpInputRef={otpInputRef}
          otpError={otpError}
          _handleOTP={_handleOTP}
          focusedInput={focusedInput}
          otpValue={otpValue}
          confirmOTP={confirmOTP}
          setFocusedInput={setFocusedInput}
          close={() => setOtpModal(false)}
          _handleSubmitOTP={_handleSubmitOTP}
        />
      )}
    </div>
  );
}
